/**
 * HomeRecruitBanner.jsx — Nov 4 2026
 * Small homepage recruitment banner → /join-our-team (cosmetic injectors).
 */
import { Link } from "react-router-dom";
import { Syringe, ArrowRight } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const T = {
  en: {
    eyebrow: "We're hiring",
    text: "We're growing! Experienced MD, NP and RN cosmetic injectors—explore opportunities with our team.",
    cta: "View Opportunities",
    href: "/join-our-team",
  },
  fr: {
    eyebrow: "Nous recrutons",
    text: "Nous grandissons ! Injecteurs esthétiques expérimentés (médecins, IP et IA) — découvrez les opportunités au sein de notre équipe.",
    cta: "Voir les opportunités",
    href: "/fr/joignez-notre-equipe",
  },
};

export default function HomeRecruitBanner() {
  const { language } = useLanguage();
  const t = T[language] || T.en;
  return (
    <section className="px-4 sm:px-6 py-6" data-testid="home-recruit-banner" aria-label={t.eyebrow}>
      <div className="max-w-6xl mx-auto rounded-2xl bg-[#0f2a24] text-white px-5 py-4 sm:px-7 sm:py-5 flex flex-col sm:flex-row sm:items-center gap-4 shadow-lg">
        <div className="flex items-start gap-3 flex-1 min-w-0">
          <span className="shrink-0 w-10 h-10 rounded-full bg-amber-400/15 ring-1 ring-amber-300/40 flex items-center justify-center">
            <Syringe className="w-5 h-5 text-amber-300" />
          </span>
          <div className="min-w-0">
            <p className="font-mono-label text-[10px] tracking-[0.3em] text-amber-300 mb-1">{t.eyebrow}</p>
            <p className="text-sm sm:text-base text-stone-100 leading-snug">{t.text}</p>
          </div>
        </div>
        <Link to={t.href}
          className="shrink-0 inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full bg-amber-400 text-[#0f2a24] text-sm font-bold hover:bg-amber-300 transition-colors min-h-[44px]"
          data-testid="home-recruit-banner-cta">
          {t.cta} <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </section>
  );
}
